import { checkExists, getCourseURL } from '../../../api/commonHTTP';
import {
    validateBarrierNameId,
    validateContractIds,
    validateCourseDescription,
    validateCourseName,
    validateHealthInformationIds,
    validateModuleDescription,
    validateModuleName,
    validateModuleTemplateSessionData,
    validateModuleTemplatesNumber,
    validateSessionNumber,
    validateSmartTargetAction,
    validateSmartTargetName,
    validateUniqueNames} from '../utils/validationFunctions';

export const validate = (newEntry, singleModule) => {
    let newErrors = {};

    newErrors = validateCourseName(newEntry.name, newErrors);
    newErrors = validateCourseDescription(newEntry.description, newErrors);
    newErrors = validateContractIds(newEntry.contractIds, newErrors);
    if (newEntry.healthInformationCaptured)
        newErrors = validateHealthInformationIds(newEntry.healthInformationIds, newErrors);
    if (newEntry.modularCourse) {
        newErrors = validateModuleTemplatesNumber(newEntry.moduleTemplates, newErrors);
        newErrors = validateUniqueNames(newEntry.moduleTemplates, newErrors);
        if (newEntry.sessionBased)
            newErrors = validateModuleTemplateSessionData(newEntry.moduleTemplates, newErrors);
    } else {
        newErrors = validateModuleName(singleModule.name, newErrors);
        newErrors = validateModuleDescription(singleModule.description, newErrors);
        if (newEntry.sessionBased)
            newErrors = validateSessionNumber(singleModule.sessionNumber, newErrors);
        if (singleModule.smartTarget) {
            newErrors = validateSmartTargetName(singleModule.smartTarget.name, newErrors);
            newErrors = validateBarrierNameId(singleModule.smartTarget.barrierNameId, newErrors);
            newErrors = validateSmartTargetAction(singleModule.smartTarget.action, newErrors);
        }
    }

    return newErrors;
};

export const checkCourseName = async (courseName) => {
    return await checkExists(getCourseURL() + `rest/course-template/exists/${courseName}`).then(
        (ret) => ret
    );
};
